export const WarningAlt = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16 20L16 13" stroke="currentColor" stroke-width="2"/>
<circle cx="16" cy="23.5" r="1" fill="currentColor" stroke="currentColor"/>
<path d="M16.8609 6.42263L28.7197 26.4913C29.1136 27.1579 28.633 28 27.8587 28H4.14125C3.36695 28 2.88641 27.1579 3.28032 26.4913L15.1391 6.42264C15.5261 5.76761 16.4739 5.76761 16.8609 6.42263Z" stroke="currentColor" stroke-width="2"/>
</svg>`;
